import {request, serviceUrl} from "@/utils/request";

// 获取视频信息
export function getConnectCamera(cameraRtspEnum, username, password, ip, channel) {
  return request({
    method: 'post',
    url: serviceUrl.cameraService + '/camera/connect',
    data: {
      cameraRtspEnum: cameraRtspEnum,
      username: username,
      password: password,
      channel: channel,
      ip: ip
    }
  })
}

// 摄像头心跳 5秒一次
export function cameraHeartbeat(cameraId) {
    return request({
        method: 'put',
        url: serviceUrl.cameraService + '/camera/heartbeat',
        params: {
            cameraId
        }
    })
}
